import React, {memo} from "react"
import {Link} from "react-router-dom"
import {classNames} from "scholastic-client-components/src/SharedPackages/classnames"
import {AppPaths} from "../../lib/routing"
import {Text} from "scholastic-client-components/src/ui/Text/Text"
import styles from "./Policies.module.scss"
import {Trans, useTranslation} from "react-i18next"

interface PoliciesProps {
    by: "login" | "registration"
    disabled: boolean
}

export const Policies: React.FC<PoliciesProps> = memo(({by, disabled}) => {
    const {t} = useTranslation()
    return (
        <div data-cy={"policies"} style={{textAlign: "center"}}>
            <Text small color={"warm-grey"}>
                <Trans
                    t={t}
                    i18nKey={
                        by === "login"
                            ? "auth_portal:policies_agreement.login"
                            : "auth_portal:policies_agreement.registration"
                    }
                    components={{
                        lbr: <br />,
                        serviceLink: (
                            <Link
                                target={"_blank"}
                                className={classNames(disabled && styles.disabled)}
                                to={AppPaths.Terms}
                            />
                        ),
                        privacyLink: (
                            <Link
                                target="_blank"
                                className={classNames(disabled && styles.disabled)}
                                to={AppPaths.Privacy}
                            />
                        ),
                    }}
                />
            </Text>
        </div>
    )
})
